import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

// Inicializar Sentry
Sentry.init({
  dsn: "https://d42b5dd3b44ae0cd6f99c690a7436e64@o233376.ingest.us.sentry.io/4510340762370048",
  
  // Environment
  environment: import.meta.env.MODE,
  
  // Integração com React Router
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  
  // Performance Monitoring
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  
  // Release tracking
  release: `receitas-express@${import.meta.env.VITE_APP_VERSION || '1.0.0'}`,
  
  // Filtrar erros conhecidos
  beforeSend(event, hint) {
    const error = hint.originalException;
    
    // Ignorar erros de AdBlockers
    if (error && error.toString().includes('adblock')) {
      return null;
    }
    
    // Ignorar erros de extensões do browser
    if (event.exception?.values?.[0]?.stacktrace?.frames?.some(
      frame => frame.filename?.includes('chrome-extension://') || 
               frame.filename?.includes('moz-extension://')
    )) {
      return null;
    }
    
    return event;
  },
  
  // Habilitar apenas em produção
  enabled: import.meta.env.PROD,
});

// Configurar variante A/B inicial
const pathname = window.location.pathname;
const variant = pathname === '/b' ? 'B' : 'A';
Sentry.setTag('ab_variant', variant);

createRoot(document.getElementById("root")!).render(<App />);
